import { supabase } from './supabase';

/** Dev only (web): point the app at another API, e.g. the local Next server, by opening it with
 *  ?api=http://localhost:9002 — remembered in this browser; ?api=off clears it. Expo bakes the
 *  .env value into the bundle, so a start-time env var can't do this. Never active in production. */
function devApiOverride(): string | null {
  if (!__DEV__ || typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const q = new URLSearchParams(window.location.search).get('api');
    if (q === 'off') window.localStorage.removeItem('olmps.devApiBase');
    else if (q && /^https?:\/\//.test(q)) window.localStorage.setItem('olmps.devApiBase', q.replace(/\/$/, ''));
    return window.localStorage.getItem('olmps.devApiBase');
  } catch {
    return null;
  }
}

const API_BASE_URL = devApiOverride() ?? process.env.EXPO_PUBLIC_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error('Missing EXPO_PUBLIC_API_BASE_URL — create apps/mobile/.env (see .env.example).');
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;

  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(init.headers ?? {}),
    },
  });

  if (!res.ok) {
    let detail = '';
    try {
      const body = await res.json();
      detail = body?.error ? `: ${body.error}` : '';
    } catch {
      // non-JSON error body
    }
    throw new Error(`API ${res.status}${detail}`);
  }
  return (await res.json()) as T;
}
